module.exports = __webpack_public_path__ + "static/media/offer_ad_image.d02e6fc9.png";